import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { withSizes } from 'react-sizes';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { selectDate, selectDateDefault } from "../../redux/actions";
import { HotelParamsLine, DropdownContainer, DatePicker, SelectorModalMobile } from "../index";
import { getCategory, slugify } from '../../utils';
import { initialState } from '../../redux/reducers/userPreferencesReducer';
import { Router } from "../../routes";

const initialUserPreferences = initialState;
const { ParamsOption } = HotelParamsLine;

const mapStateToProps = state => ({
  date: state.userPreferences.date,
  product: state.userPreferences.product,
  market: state.userPreferences.city.market,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleDateSelection: selectDate,
  handleDefaultDateSelection: selectDateDefault,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class DateSelector extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    date: PropTypes.string,
    handleDateSelection: PropTypes.func,
    currentDropdown: PropTypes.string,
    handleDropdownClick: PropTypes.func,
    handleCloseDropdown: PropTypes.func,
    handleDefaultDateSelection: PropTypes.func,
    product: PropTypes.string,
    market: PropTypes.string,
    total: PropTypes.number,
  };

  handleDayChange = (date, initial = false) => {
    const { handleDateSelection, handleCloseDropdown, product, market, handleDefaultDateSelection } = this.props;
    const formattedDate = initial ? initialUserPreferences.date : moment(date).format('YYYY-MM-DD');

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      date: formattedDate,
    }, { shallow: true });

    if (initial) {
      handleDefaultDateSelection();
      handleCloseDropdown();
      return;
    }
    handleDateSelection(formattedDate);
    handleCloseDropdown();
  };

  render() {
    const { handleDayChange } = this;
    const { currentDropdown, handleDropdownClick, handleCloseDropdown, date, isMobile, total } = this.props;

    return (
      <Fragment>
        <ParamsOption
          type="button"
          name="date"
          onClick={handleDropdownClick}
          isOpened={currentDropdown === 'date'}
          isActive={date}
        >
          {date ? moment(date).format('MMM D YYYY') : 'Select a date'}
        </ParamsOption>
        {currentDropdown === 'date' && !isMobile &&(
          <DropdownContainer name="date" handleCloseButtonClick={handleCloseDropdown} onClickOutside={handleCloseDropdown}>
            <DatePicker selectedDate={date} handleDayClick={handleDayChange} />
          </DropdownContainer>
        ) || currentDropdown === 'date' &&
        (
          <SelectorModalMobile name="date" handleCloseButtonClick={handleCloseDropdown} handleClearButtonClick={() => handleDayChange(null, true)} total={total} title={moment(date).format('MMM DD YYYY')}>
            <DatePicker selectedDate={date} handleDayClick={handleDayChange} monthsShown={12} />
          </SelectorModalMobile>
        )}
      </Fragment>
    );
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

export default withSizes(mapSizesToProps)(DateSelector);
